'use strict';

var psrServices = angular.module('psrApp.services', ['psrApp.constants']);

psrServices.factory('user', ['$cookies','$http', function ( $cookies, $http ) {
    var user = {};

    var authenticationCookies =
    {
        UC: $cookies['UC'],
        UL: $cookies['UL']
    };
    user.name = '';
    user.age = '';
    user.email = '';

    user.isAuthenticated = function () {
        if ( ( authenticationCookies.UC === "0" || authenticationCookies.UC === undefined ) && ( authenticationCookies.UL === "0" || authenticationCookies.UL === undefined ) ) {
            return false;
        } else {
            return true;
        };
    };

    user.fetchUserData = function () {
        if ( this.isAuthenticated() ) {
            return true;
        } else {
            return false;
        };
    };

    user.removeAuthenticationCookies = function () {
        delete $cookies['UC'];
        delete $cookies['UL'];
    };
    return user;
}]);

psrServices.factory('environment', ['$http','domains', function ( $http, domains ){
    var environment = {};
    return domains;
}]);

psrServices.factory('customHttp', ['$http','environment', function ( $http, environment ){
    var currentDay = new Date;
    var today = currentDay.getFullYear() + currentDay.getMonth() + currentDay.getDay();

    var oldIe = false;

    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
        var version = new Number(RegExp.$1);
        if (version == 8) {
            oldIe = true;
        }
    }
    var customHttp = {
        get: function(uri) {
            if (oldIe === false) {
                var promise = $http({
                    method: 'GET',
                    url: environment.static + uri + '?t=' + today
                }).then(function(response){
                    return response.data;
                });
            } else {
                var promise = $http({
                    method: 'GET',
                    url: '/fwAngular_compatibility_old_brownser?fullPath=true&json=true&path=' + uri
                }).then(function(response){
                    return response.data;
                });
            }

            return promise;
        },
        post: function(uri) {
            var promise = $http({ method: 'POST', url: environment.https + uri }).then(function(response){
                return response.data;
            });
            return promise;
        }
    };
    return customHttp;
}]);
